import React, { useEffect, useState } from "react";
import "./Website_ugread.css";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { faFire } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AllAnnouncement } from "../../../../features/admin/common/Slice";
import UPI_Withdrawal_Remainder from "../Common_Modal/UPI_Withdrawal_Remainder/UPI_Withdrawal_Remainder";
import { useNavigate } from "react-router-dom";

function Website_ugread() {
  const dispatch = useDispatch();
  const announcements = useSelector((state) => state.common.announcements);
  useEffect(() => {
    dispatch(AllAnnouncement());
  }, [dispatch]);

  const navigate = useNavigate();

  const [isSpeaking, setIsSpeaking] = useState(false);

  const handleSpeak = () => {
    const text = announcements?.[0]?.description;
    if (!text) return;

    if (isSpeaking) {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "hi-IN"; // change to "hi-IN" for Hindi
    utterance.rate = 1; // speed 0.5 - 2
    utterance.pitch = 1; // pitch 0 - 2

    utterance.onend = () => setIsSpeaking(false);
    utterance.onerror = () => setIsSpeaking(false);

    window.speechSynthesis.speak(utterance);
    setIsSpeaking(true);
  };
  return (
    <>
      <section className="Website_ugread">
        <div className="upgrade-bar">
          <div className="upgrade-left">
            <div
              className="icon-wrapper"
              onClick={handleSpeak}
              style={{ cursor: "pointer" }}
            >
              {isSpeaking ? <FaVolumeMute /> : <FaVolumeUp />}
            </div>
            {/* <p className="upgrade-text">{announcements?.[0]?.description}</p> */}
            <div className="upgrade-text-wrapper">
              <div className="scroll-text">
                <p className="upgrade-text">
                  {announcements?.[0]?.description}
                </p>
                <p className="upgrade-text">
                  {announcements?.[0]?.description}
                </p>
              </div>
            </div>
          </div>

          <Button
            className="btn_register_bg"
            onClick={() => navigate("/announcement")}
          >
            <FontAwesomeIcon icon={faFire} /> Detail
          </Button>
        </div>
      </section>
    </>
  );
}

export default Website_ugread;
